import React from 'react';
import moment from 'moment-timezone';
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import { isCentralTimeZone, getCurDateInCentralTz } from '../../../helpers/Tools';
import LaunchVideoMessage from '../../common/LaunchVideoMessage';
import AppointmentECheckinDashboardMessage from "../../common/AppointmentECheckinDashboardMessage";
import * as Tools from "../../../helpers/Tools";
import * as types from "../../../constants/actionTypes";
import { logUI } from "../../../api/andyliticsApi";

class VideoVisitConfirmationStatus extends React.Component {

    componentDidMount() {
        const { videoVisitConfirmationData } = this.props;
        logUI("MBHWeb.UI.VideoVisitConfirmationStatus.ComponentDidMount", new Date(), Tools.getURLPath());
        //const { schedule, eCheckInStatusSuccess } = this.props;
        const csnId = this.props.videoVisitCSN;
        if (csnId)
            this.props.getEncryptedCSN(csnId); // Trigger Encrypt API. Only passing csnId and the token is passed at the saga level.
    }

    eCheckInClick = () => {
        const { EncryptedCSN } = this.props;
        let EcheckInRoute = "/appointments";
        if (EncryptedCSN) {
            EcheckInRoute = EncryptedCSN ? { pathname: "/EcheckIn", state: { csnId: EncryptedCSN.CSNHash } } : { pathname: "/appointments" };
        }
        this.props.history.push(EcheckInRoute);
    }

    render() {
        const { failedStatus, hasMyChart, enableEcheckinMandatoryUpdates, timezone, showTimeZoneMessage } = this.props;
        const { patientName, visitDateTime, visitDay } = this.props.videoVisitConfirmationData;
        const selectedVisitDateTime = showTimeZoneMessage ? Tools.convertDateToCentralTz(visitDateTime) : moment.utc(visitDateTime).local();
        const scheduledDay = Tools.isCentralTimeZone() && moment(selectedVisitDateTime).isSame(moment().local(), 'day') ? "Today"
            : moment(selectedVisitDateTime).format("MMM DD").toUpperCase();
        const dateTime = moment(selectedVisitDateTime).format("h:mm a").toUpperCase();
        const numberOfDaysDiff = Tools.differenceInDays(selectedVisitDateTime);
        const { eCheckInDays } = serverData.data;
        return (
            <React.Fragment>
                {!failedStatus && hasMyChart && numberOfDaysDiff <= parseInt(eCheckInDays) && enableEcheckinMandatoryUpdates &&
                    <div className="col-12 echeck-in-container">
                        <span>eCheck-in is required to launch your video visit</span>
                        <button className="btn btn-primary" onClick={this.eCheckInClick}>BEGIN ECHECK-IN</button>
                    </div>
                }
                <div className="row confirm-appt-details-container">
                    <div className="col-12 col-md-4 confirm-dr-details">
                        <div className="appt-schedule-for">
                            <div className="appt-heading">
                                <span>Appointment Scheduled For:</span>
                            </div>
                            <div><span className="visit-time">{patientName}</span></div>
                        </div>
                    </div>
                    <div className="col-12 col-md-1 confirm-seperator" />
                    <div className="col-12 col-md-7 confirm-doctor-addl-details">
                        <div className="row">
                            <div className="col-12 col-md-8 confirm-visit-info-container">
                                <div className="item-details">
                                    <div className="row">
                                        <div className="col-12 item-name">
                                            <span>Baylor Scott & White Provider</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-4 text-end video-visit-date">
                                <div>
                                    <div className="visit-date">{scheduledDay}</div>
                                    <div className="visit-time"><span>{dateTime} {showTimeZoneMessage ? timezone : Tools.getTimeZone()}</span></div>
                                </div>
                            </div>
                            {!failedStatus &&
                                <div className="col-12 col-lg-8 launch-video-visit">                               
                                    <AppointmentECheckinDashboardMessage visitDateTime={visitDateTime} />         
                                </div>
                            }
                            
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        videoVisitEnabledMinutesAfterStart: state.session.serverData && state.session.serverData.videoVisitEnabledMinutesAfterStart ? state.session.serverData.videoVisitEnabledMinutesAfterStart : "45",
        hasMyChart: state.domain.hm,
        enableEcheckinMandatoryUpdates: state.session.serverData && state.session.serverData.enableEcheckinMandatoryUpdates ? state.session.serverData.enableEcheckinMandatoryUpdates : false,
        EncryptedCSN: state.epic.encryptCSN
    }
};
const mapDispatchToProps = (dispatch) => {
    return {
        getEncryptedCSN: (csnId) => {
            dispatch({ type: types.GET_EPIC_ENCRYPT_CSN, csnId });
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(VideoVisitConfirmationStatus));
